export default __webpack_public_path__ + "static/media/npm-original-wordmark.2c362bda.svg";